import TagNavigatorItem from "./tag_navigator_item.vue"

import { Api, ListResponse } from "@/api"
import { Tag } from "@/tag/models"

import * as _ from "lodash"
import Vue from "vue"
import { Component, Watch, Prop } from "vue-property-decorator"

@Component({ name: "TagNavigator", components: { TagNavigatorItem } })
export default class TagNavigator extends Vue {
  @Prop() readonly activeTagId: string | undefined

  loading = false
  failed = false
  tagsResponse: ListResponse<Tag> | null = null
  featuredTags: Tag[] = []
  normalTags: Tag[] = []
  search = ""
  api = Api.createFromEnv()
  loadTagsDebounced = _.debounce(this.loadTags, 500)

  mounted() {
    this.loadTags(0)
  }

  @Watch("search")
  onSearchChange() {
    this.loading = true
    this.loadTagsDebounced(0)
  }

  async loadTags(offset = 0): Promise<void> {
    this.loading = true
    this.failed = false

    const response = await this.api
      .getList<Tag>("tags", { offset: offset.toString() })
      .catch(error => {
        console.error(error)
        return null
      })

    if (response !== null) {
      this.tagsResponse = response

      for (const tag of response.items) {
        if (tag.featured === true) {
          this.featuredTags.push(tag)
        } else {
          this.normalTags.push(tag)
        }
      }
    } else {
      this.failed = true
    }

    this.loading = false
  }

  onTagClick(tag: Tag) {
    this.$emit("tagClick", tag)
  }
}
